import React from 'react';

import { find, pick, propEq, uniq } from 'ramda';
import { useFormContext } from 'react-hook-form';

import { IRoomOption } from 'components/Pages/Admin/Itinerary/Details/RoomsSelect/types';
import { ERoomBasis } from 'detailsv2/structure';

import { useAccomodationWizardContext } from '../../../context';
import { usePropertyPageQuery } from '../../../hooks';
import { TFormValues } from '../../types';
import { roomToOptionAdapter } from '../functions';
import { formatToSnakeCase, normalizeName } from './functions';

export const useRooms = () => {
  const { createdRooms, setCreatedRooms } = useAccomodationWizardContext();
  const { watch } = useFormContext<TFormValues>();

  const selectedPropertyPage = watch('attachedPage');
  const roomBasis = watch('data.roomBasis') || '';
  const rooming = watch('data.rooming') || [];

  const basisOfStay = roomBasis ? { id: formatToSnakeCase(roomBasis), name: roomBasis } : null; // TODO refactor

  const propertyQueryRes = usePropertyPageQuery({ pageId: selectedPropertyPage?.id });

  const handleRoomCreation = (room: IRoomOption) => setCreatedRooms((prev) => [...prev, room]);

  const rooms = React.useMemo(() => {
    const propertyRooms = propertyQueryRes.data?.rooms || [];
    const handledPropertyRooms = propertyRooms.map(roomToOptionAdapter);
    const filteredCreatedRooms = createdRooms.filter(
      (room) => !handledPropertyRooms.some((r) => r.value === room.value || r.isCustom),
    );

    const rooms = [...handledPropertyRooms, ...filteredCreatedRooms].map((room) => {
      const count = find(propEq(room.value, 'value'), rooming)?.count ?? room.count;
      return { ...room, count };
    });

    return rooms.map((room) => pick(['label', 'value', 'count', 'isCustom', 'media'], room));
  }, [propertyQueryRes.data?.rooms, createdRooms, rooming]);

  const loadBasisOfStayOptions = () => {
    // TODO refactor, the selector should accept a native data type and then transform the label and name using additional callbacks
    return uniq([...Object.values(ERoomBasis), normalizeName(roomBasis)])
      .filter(Boolean)
      .map((name) => {
        const id = formatToSnakeCase(name);
        return { id, name, value: id, label: name };
      });
  };

  return {
    rooms,
    handleRoomCreation,
    basisOfStay,
    loadBasisOfStayOptions,
  };
};
